<div class="visualizationMethod">
  <div class="label">Select Visualization Method</div>
  <div class="container">
    <div class="visualizationMenu" (insClickOutside)="clickOutside()">
      <div class="icons" #selectedRow [ngClass]="{ optionsOpen: showSelector }">
        <mat-icon class="visualizationIcon" [svgIcon]="value" (click)="openSelector(selectedRow, $event)"></mat-icon>
        <mat-icon class="arrowIcon" svgIcon="dropdown.expand-more" (click)="openSelector(selectedRow, $event)"></mat-icon>
      </div>
      @if (showSelector) {
        <div class="visualizationOptions" [style.top.px]="calculatedTopForList">
          <ul class="options">
            @for (item of types; track item) {
              <li class="method" (click)="selectVisualizationMethod(item.type)" [ngClass]="{ selected: value == item.type }">
                <mat-icon class="method-icon" [svgIcon]="item.type"></mat-icon>
                <span>{{item.label}}</span>
              </li>
            }
          </ul>
        </div>
      }
    </div>
    @if (value != visualizationMethods.STATUS_TAG) {
      <div class="editTemplate textButton" (click)="editTemplate()">Edit Template</div>
    }
  </div>
</div>